import React, { useEffect, useRef,useState } from "react";
import Highcharts from "highcharts";
import { Card, Col, Row } from "reactstrap";
import "./CSS/LineChart.css";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";


const LineChart = (props) => {
   
  const [isGraphVisible, setIsGraphVisible] = useState(true);

  useEffect(() => {
    const options = {
      chart: {
        type: "spline",
        height: 550,
      },

      title: {
        text: props.config.text,
      },
      legend: {
        align: "center",
        verticalAlign: "top",
        symbolHeight: 12,
        symbolWidth: 12,
        symbolRadius: 6,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: props.config.categories,
        crosshair: true,
        title: {
          text: "BIN",
          style: {
            fontSize: "24px",
            fontWeight: "bold",
            color: "#2c2e34",
          },
        },
      },

      yAxis: {
        min: 0,

        title: {
          text: "Defect Count",
          style: {
            fontSize: "24px",
            fontWeight: "bold",
            color: "#2c2e34",
          },
        },
      },
      tooltip: {
        formatter: function () {
          let content =
            // '<span style="font-size:10px">' + this.x + '</span><br>' +
            '<span style="color:' +
            this.series.color +
            ';padding:0">Batch Name: </span>' +
            "<b>" +
            this.point.batch_name +
            "</b><br>" +
            '<span style="color:' +
            this.series.color +
            ';padding:0">Date: </span>' +
            "<b>" +
            this.point.date +
            "</b><br>" +
            '<span style="color:' +
            this.series.color +
            ';padding:0">Start Time: </span>' +
            "<b>" +
            this.point.batch_start_time +
            "</b><br>" +
            '<span style="color:' +
            this.series.color +
            ';padding:0">End Time: </span>' +
            "<b>" +
            this.point.batch_end_time +
            "</b><br>";

          if (this.point.duration !== undefined) {
            content +=
              '<span style="color:' +
              this.series.color +
              ';padding:0">Duration: </span>' +
              "<b>" +
              this.point.duration +
              " Mins </b><br>";
          }

          if (this.point.idle_time !== undefined) {
            content +=
              '<span style="color:' +
              this.series.color +
              ';padding:0">Idle Time: </span>' +
              "<b>" +
              this.point.idle_time?.minutes +
              " mins " +
              this.point.idle_time?.seconds +
              " Seconds" +
              "</b><br>";
          }

          content +=
            '<span style="color:' +
            this.series.color +
            ';padding:0">Efficiency: </span>' +
            '<b style="color:#0F8A0C">' +
            this.point.efficiency +
            " %" +
            "</b><br>";
          return content;
        },
        shared: true,
        useHTML: true,
      },

      plotOptions: {
        spline: {
          point: {},
        },
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },

      series: props.config.series,
    };

    Highcharts.chart("line", options);
  }, [props.config]);
  const handleToggleGraph = () => {
    setIsGraphVisible(!isGraphVisible);
  };

  return (
    <>
      <Col>
        <Row>
          <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}></Col>
          <Col>
            {isGraphVisible && (
              <p className="text-center fs-4">
                <strong>Total No. of defects per Vehicle for dd/mm/yyyy</strong>
              </p>
            )}
          </Col>

          <Col xs={1} sm={1} md={1} lg={1} xl={1} xxl={1}>
            <Card
              className={`d-flex align-items-center flex-wrap HideCard ${
                isGraphVisible ? "visible" : "hidden"
              }`}
            >
              <Row>
                <Col
                  className="justify-content-center text-center align-item-center"
                  onClick={handleToggleGraph}
                >
                  {isGraphVisible ? "Hide Graph" : "Show Graph"}
                </Col>
                <Col>
                  {isGraphVisible ? (
                    <VisibilityOffIcon onClick={handleToggleGraph} />
                  ) : (
                    <VisibilityIcon onClick={handleToggleGraph} />
                  )}
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <div id="line" style={{ display: isGraphVisible ? "block" : "none" }} />
      </Col>
    </>
  );
};

export default LineChart;